/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getKeys} from '../api'

 export const useQueryGetKeys = createReactQueryHook('getKeys', getKeys)
